import { render } from "./loginBox.vue?vue&type=template&id=2f607799&scoped=true"
import script from "./loginBox.vue?vue&type=script&lang=js"
export * from "./loginBox.vue?vue&type=script&lang=js"

import "./loginBox.vue?vue&type=style&index=0&id=2f607799&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f607799"]])

export default __exports__